import { flexRender, type Table } from '@tanstack/react-table'
import Card from '../Card'
import type { ColumnMeta } from './GenericTable'

export function GenericTableMobileFooter<T>({ table }: { table: Table<T> }) {
  const footerGroups = table.getFooterGroups()

  const hasFooterContent = footerGroups.some((group) =>
    group.headers.some((header) => header.column.columnDef.footer && !header.isPlaceholder),
  )

  if (!hasFooterContent) return null

  const footerItems = footerGroups.flatMap((footerGroup) =>
    footerGroup.headers
      .filter((header) => !header.isPlaceholder && header.column.columnDef.footer)
      .map((header) => ({
        id: header.id,
        content: flexRender(header.column.columnDef.footer, header.getContext()),
        meta: header.column.columnDef.meta as ColumnMeta | undefined,
        header: header.column.columnDef.header,
        context: header.getContext(),
      })),
  )

  return (
    <Card className="w-full mb-4 bg-white px-4">
      {footerItems.map((item) => {
        const label = item.meta?.mobileFooterLabel ? item.meta.mobileFooterLabel : flexRender(item.header, item.context)

        return (
          <div
            key={item.id}
            className={`flex flex-row py-3 w-full justify-between border-b border-borderGray last:border-none`}
          >
            <div className={'text-sm text-secondaryText'}>{label}</div>
            <div className={'text-sm text-primaryText text-right font-medium'}>{item.content}</div>
          </div>
        )
      })}
    </Card>
  )
}
